import React from "react";
import { Route, Routes } from "react-router-dom";
import UserManagements from "../pages/UserManagements";
import Main from "../components/Main";
import Login from "../pages/Login";
import {
  GuardedLogin,
  GuardedRoute,
} from "../services/authentication/GourdedRoutes";
import Otppage from "../pages/Otppage";
import MapManagement from "../pages/MapManagement";
import ContentManagement from "../pages/ContentManagement";
import PlacesManagements from "../pages/PlacesManagements";
import TagManagement from "../pages/TagManagement";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import Profile from "../pages/Profile";
import ChangePassword from "../pages/ChangePassword";
import Testing from "../pages/Testing";
import HelpAndSupport from "../pages/HelpAndSupport";
import UploadedImage from "../pages/UploadedImage";
import RatingAndRiview from "../pages/RatingAndRiview";
import Journeys from "../pages/Journeys";
import PublicAppContent from "../pages/PublicAppContent";

function AllRoutes() {
  return (
    <>
      <Routes>
        <Route path="/public/:key" element={<PublicAppContent />} />

        <Route path="/" element={<GuardedLogin />}>
          <Route path="/" element={<Login />} />
        </Route>
        <Route exact path="/login" element={<GuardedLogin />}>
          <Route path="/login" element={<Login />}></Route>
        </Route>

        <Route path="/dashboard" element={<GuardedRoute />}>
          <Route path="/dashboard" element={<Main />} />
        </Route>
        <Route path="/userManagement" element={<GuardedRoute />}>
          <Route path="/userManagement" element={<UserManagements />} />
        </Route>

        <Route path="/otp" element={<Otppage />}></Route>

        <Route path="/mapmanagement" element={<MapManagement />}></Route>
        <Route path="/contentManagement" element={<GuardedRoute />}>
          <Route
            path="/contentManagement"
            element={<ContentManagement />}
          ></Route>
        </Route>
        <Route path="/placesManagement" element={<GuardedRoute />}>
          <Route
            path="/placesManagement"
            element={<PlacesManagements />}
          ></Route>
        </Route>
        <Route path="/tagManagement" element={<GuardedRoute />}>
          <Route path="/tagManagement" element={<TagManagement />}></Route>
        </Route>

        <Route path="/forgotPassword" element={<ForgotPassword />}></Route>

        <Route path="/resetPassword" element={<ResetPassword />}></Route>

        <Route path="/profile" element={<GuardedRoute />}>
          <Route path="/profile" element={<Profile />}></Route>
        </Route>
        <Route path="/changePassword" element={<GuardedRoute />}>
          <Route path="/changePassword" element={<ChangePassword />}></Route>
        </Route>

        <Route path="/testing" element={<Testing />}></Route>
        <Route path="/helpAndSupport" element={<GuardedRoute />}>
          <Route path="/helpAndSupport" element={<HelpAndSupport />}></Route>
        </Route>

        <Route path="/uploadedImage" element={<GuardedRoute />}>
          <Route path="/uploadedImage" element={<UploadedImage />}></Route>
        </Route>

        <Route path="/ratingAndReview" element={<GuardedRoute />}>
          <Route path="/ratingAndReview" element={<RatingAndRiview />}></Route>
        </Route>
        <Route path="/journeyManagement" element={<GuardedRoute />}>
          <Route path="/journeyManagement" element={<Journeys />}></Route>
        </Route>

        <Route path="*" element={<Login />}></Route>
      </Routes>
    </>
  );
}

export default AllRoutes;
